export const EMPLOYEE_COMPANY_GRAPH_QUERY = Object.freeze({
  graph: {
    allowances: {
      mealAllowance: true,
      holidayAllowance: true,
      travelAllowance: true,
      workFromHomeAllowance: true,
    },
    otherAllowances: {
      otherIncome: true,
      otherExpenses: true,
      suspension: true,
      bonus: true,
      nonMonetaryBenefit: true,
    },
    currencies: {
      mealAllowanceCurrency: true,
      holidayAllowanceCurrency: true,
      travelAllowanceCurrency: true,
      workFromHomeAllowanceCurrency: true,
    },
    applicationSettings: {
      isHr: true,
      holidayDaysTracker: true,
      trackerStartDate: true,
      foreignWorkPermitTracker: true,
      isSector: true,
      weekendLeaves: true,
      isGrossBonus: true,
    },
    calculationSettings: {
      bonus: true,
      suspension: true,
      nonMonetaryBenefit: true,
    },
    bonusVariations: {
      enabled: true,
      types: true,
    },
    suspensionVariations: {
      enabled: true,
      types: true,
    },
    nonMonetaryBenefitVariations: {
      enabled: true,
      types: true,
    },
    sectors: true,
  },
});
